import React from 'react';
import { toRegistrationIdSuffix } from '../utils/studentRegistrationId';

export default function StudentRegistrationIdField({
    value,
    onChange,
    error,
    disabled = false,
    inputId = 'registrationId',
    align = 'left'
}) {
    return (
        <div style={{ width: '100%', maxWidth: '420px', textAlign: align }}>
            <label htmlFor={inputId} style={{ display: 'block', fontWeight: 600, marginBottom: 6, color: '#374151' }}>
                Registration ID <span style={{ color: '#dc2626' }}>*</span>
            </label>
            <div style={{ display: 'flex', alignItems: 'center', height: 42 }}>
                <span style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 42,
                    padding: '0 14px',
                    background: '#F47B20',
                    color: '#fff',
                    fontWeight: 700,
                    borderRadius: '8px 0 0 8px',
                    letterSpacing: '0.5px',
                    fontSize: 14,
                    lineHeight: 1,
                    flexShrink: 0,
                    boxSizing: 'border-box'
                }}>
                    ULK-
                </span>
                <input
                    id={inputId}
                    type="text"
                    value={value}
                    onChange={(e) => onChange(toRegistrationIdSuffix(e.target.value))}
                    placeholder="Enter unique ID"
                    required
                    disabled={disabled}
                    autoComplete="off"
                    style={{
                        flex: 1,
                        minWidth: 0,
                        height: 42,
                        margin: 0,
                        padding: '0 14px',
                        border: '1px solid #d1d5db',
                        borderLeft: 0,
                        borderRadius: '0 8px 8px 0',
                        fontSize: 14,
                        lineHeight: '42px',
                        boxSizing: 'border-box',
                        background: disabled ? '#f5f5f5' : '#fff',
                        color: '#333',
                        outline: 'none'
                    }}
                />
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
                Always starts with ULK-. The full ID must be unique.
            </div>
            {error && <div style={{ fontSize: 13, color: '#dc2626', marginTop: 4 }}>{error}</div>}
        </div>
    );
}
